import React, { useContext, useState } from 'react'
import Wizard from '../Wizard'
import BrandsContext from '../../../contexts/BrandsContext'
import { getAddBrandParams } from '../../../utils/payload-generator'
import { useHistory, useLocation } from 'react-router-dom'
import { LoaderDialog } from 'functional-foundations'

type PropsType = {
    goToListPage(): unknown
}

const Create = ({ goToListPage }: PropsType) => {
    const [loading, setLoading] = useState(false)
    const {
        setBrandNetworkError,
        addBrand,
        networkPending
    } = useContext(BrandsContext)
    const { pathname } = useLocation()
    const history = useHistory()

    const appPath = '/brands'
    const basePath = `${pathname.split(appPath)[0]}${appPath}`

    const onSubmitHandler = async (data) => {
        if (networkPending) return

        setBrandNetworkError(null)
        setLoading(true)
        try {
            setLoading(true)
            const addParams = await getAddBrandParams(data, {
                onSuccess: () => history.push(basePath)
            })
            await addBrand(addParams)
        } catch (err) {
            setBrandNetworkError('Something Went Wrong')
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    return <div>
        <Wizard
            onSubmit={onSubmitHandler}
            goToListPage={goToListPage}
        />
        <LoaderDialog
            isOpen={loading}
            title={'Processing your payment...'}
            subtitle='Please wait!'
            data-testid='loader-dialog'
        />
    </div>
}

export default Create
